<template>
    <div>
        <v-row no-gutters align="center">
            <v-col cols="6">
                <modal-cadu @input="closeSucesso" :close="close" :width="452" :value="show">
                    <div slot="all" class="py-12 px-10">
                        <div slot="body">
                            <v-row no-gutters>
                                <v-col cols="12" align="center">
                                    <div><icon name="check" :size="70" :style="iconStyle"/></div>
                                </v-col>
                                <v-col cols="12" align="center">
                                    <div class="font-secundaria headline font-weight-bold" >
                                        Sucesso
                                    </div>
                                </v-col>
                                <v-col cols="12" align="center">
                                    <div class="font-secundaria font-weight-regular" style="font-size: 18px" >
                                        {{getModalType}}
                                    </div>
                                </v-col>
                                <v-col cols="12" align="center" class="mt-5">
                                    <div>
                                        <button-cadu
                                            text="OK"
                                            @click="closeSucesso"
                                            :backColor="$vuetify.theme.themes.light.primary1"
                                        />
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <div slot="footer"></div>
                    </div>
                </modal-cadu>
            </v-col>

        </v-row>
    </div>
</template>

<script>
export default {
  props: {
    sucessType: {
      type: String,
      required: true,
      default: ''
    },
    showSucess: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      close: true,
      show: this.showSucess,
      iconStyle: {
        color: this.$vuetify.theme.themes.light.primary1
      },
      editMessage: 'Endereço editado com sucesso!',
      createMessage: 'Endereço criado com sucesso!',
      deleteMessage: 'Endereço excluido com sucesso!'
    }
  },
  methods: {
    closeSucesso () {
      if (this.show) {
        this.$emit('close')
      }
    }
  },
  computed: {
    getModalType () {
      if (this.message) {
        return this.message
      } else if (this.sucessType.toUpperCase() === 'EDIT') {
        return this.editMessage
      } else if (this.sucessType.toUpperCase() === 'NEW') {
        return this.createMessage
      } else {
        return this.deleteMessage
      }
    }
  },
  watch: {
    showSucess () {
      this.show = this.showSucess
    }
  }
}
</script>
